import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { Box, MenuItem, Typography } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import StepperCustom from "../../../components/step/Stepper";
import { icons } from "../../../assets/icons/icons";
import CardInfoComponent from "./components/CardInfo";
import { colors } from "../../../constants/colors";
import FilterSelect from "../../../components/select/filterSelect";
import { debouncedApiCall } from "../../../utils/app.utils";
import InputTextField from "../../../components/input/inputTextField";
import DropdownButton from "../../../components/button/DropdownButton";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import moment from "moment";
import ListAdvisoryRequest from "./components/ListAdvisoryRequest";
import ListConsultationRequest from "./components/ListConsultationRequest";
import { advisorApi } from "../../../api/advisor/advisor.api";
import { InputValueNewAdvisor } from "../../../domains/advisor";
import {
  allStatusAdvisorRequestUtil,
  allStatusConsultRequestUtil,
  handleColorStatusConsultRequestUtil,
} from "../../../utils/statusRequest";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { advisorRequestApi } from "../../../api/advisor-request/advisor-request.api";

type Props = {};

const ManageAdvisorDetail: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();

  const [tabStep, setTebStep] = useState(0);
  const { id } = useParams();
  const id_employee = searchParams.get("id_employee");

  const { profile } = useSelector((state: any) => state.profile);

  const [search, setSearch] = useState<string>("");
  const [inputValueSearch, setInputValueSearch] = useState({
    keyword: "",
    consultation_type: "",
    status: "",
  });
  const [inputValue, setInputValue] = useState<InputValueNewAdvisor>({
    advisor_id: 0,
    adv_fullname: "",
    adv_employee_id: "",

    adv_employee_no: "",
    adv_position: "",
    adv_position_name: "",
    adv_department: "",
    adv_department_name: "",
    start_date: new Date(),
    course: [],
    evaluation_form: 0,
    maximum_student: 0,
    count_advisor_req: 0,
    count_req_all: 0,
  });

  console.log("inputValue", inputValue);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);

  const [dataAdvisorRequest, setDataAdvisorRequest] = useState<any>([]);
  const [dataAdvisorRequestConsultaion, setDataAdvisorRequestConsultaion] =
    useState<any>([]);

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getSingleAdvisor = async (id: number) => {
    const res = await advisorApi.getAdvisorById(id);
    const data = res.data;
    if (data.status < 300) {
      // setInputValue(data.data);
      setInputValue({
        advisor_id: data.data?.id_advisor,
        adv_fullname: data.data?.first_name + " " + data.data?.last_name,
        adv_employee_id: data.data?.id_employee,

        adv_employee_no: data.data?.employee_no,
        adv_position: data.data,
        adv_position_name: "",
        adv_department: data.data?.id_department,
        adv_department_name: "",
        start_date: data.data?.advisor_start_date,
        course: data.data?.faculty_names,
        evaluation_form: data.data,
        maximum_student: data.data?.number_students,
        count_advisor_req: data.data?.count_req,
        count_req_all: data.data?.count_req_all,
      });
    } else {
      setInputValue({
        adv_fullname: "",
        adv_employee_id: "",
        adv_employee_no: "",
        adv_position: "",
        adv_position_name: "",
        adv_department: "",
        adv_department_name: "",
        start_date: new Date(),
        course: [],
        evaluation_form: 0,
        maximum_student: 0,
        count_advisor_req: 0,
        count_req_all: 0,
      });
    }
  };

  const getAdvisorRequestById = async (id: number) => {
    try {
      let query: any = {
        page: page,
        limit: pageLimit,
        sortBy: sortBy,
        sortType: sortType,
        status: inputValueSearch.status,
      };
      if (startDate) query = { ...query, sdate: startDate };
      if (endDate) query = { ...query, edate: endDate };
      if (search) query = { ...query, search: search };
      if (id_employee) query = { ...query, id_employee: id_employee };

      const res = await advisorApi.getAdvisorRequestById(id, query);
      const data = res.data;
      if (data.status < 300) {
        setDataAdvisorRequest(res.data?.data?.advisor_request?.items);
        setTotalItems(res.data?.data?.advisor_request?.meta?.totalItems || 0);
      } else {
        setDataAdvisorRequest([]);
      }
    } catch (err) {
      console.log(err)
    }
  };

  useEffect(() => {
    if (id) {
      getSingleAdvisor(parseInt(id));
      if (tabStep === 0) {
        getAdvisorRequestById(parseInt(id));
      }
    }
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    inputValueSearch,
    tabStep,
    startDate,
    endDate,
  ]);

  const fetchGetRequestConsultationAdvisorStudent = async (id: number) => {
    try {
      let query: any = {
        page: page,
        limit: pageLimit,
        sortBy: sortBy,
        sortType: sortType,
        sdate: startDate,
        edate: endDate,
        status: inputValueSearch.status,
        advisorTypeId:
          inputValueSearch.consultation_type === "ทุกเรื่องที่ขอคำปรึกษา"
            ? ""
            : inputValueSearch.consultation_type,
      };

      if (search) query = { ...query, search: search };

      const res = await advisorApi.getRequestConsultationAdvisorStudentById(
        id,
        query
      );
      const data = res.data;
      if (data.status < 300) {
        setDataAdvisorRequestConsultaion(data.data?.advisor_request?.items ?? []);
        setTotalItems(data?.data?.advisor_request?.meta?.totalItems || 0);
      } else {
        setDataAdvisorRequestConsultaion([]);
      }
    } catch (err) {
      console.log(err, 'err')
    }
  };

  useEffect(() => {
    if (id && tabStep === 1) {
      fetchGetRequestConsultationAdvisorStudent(+id);
    }
  }, [
    id,
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    inputValueSearch,
    tabStep,
    startDate,
    endDate,
  ]);

  const allStep = [
    {
      name: "คำร้องที่ปรึกษา",
      isAccept: false,
      icon: (
        <Box
          component="img"
          src={icons.user_square}
          alt="folder"
          sx={{
            cursor: "pointer",
            filter: tabStep === 0 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
    {
      name: "คำขอปรึกษา",
      isAccept: false,
      icon: (
        <Box
          component="img"
          src={icons.folder_3}
          alt="folder"
          sx={{
            cursor: "pointer",
            filter: tabStep === 1 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
  ];

  const arrayCardInfo = [
    {
      color: colors.textNormal,
      title: "จำนวนที่รับนักศึกษาได้สูงสุด",
      amount: inputValue.maximum_student
        ? parseInt(inputValue.maximum_student.toString())
        : 0,
      bgColor: colors.placeholder2,
    },
    {
      color: colors.white,
      title: "จำนวนคำร้อง",
      amount: inputValue.count_req_all
        ? parseInt(inputValue.count_req_all.toString())
        : 0,
      bgColor: colors.subPrimary,
    },
    {
      color: colors.white,
      title: "จำนวนนักศึกษาที่รับเป็นที่ปรึกษา",
      amount: inputValue.count_advisor_req
        ? parseInt(inputValue.count_advisor_req.toString())
        : 0,
      bgColor: colors.success3,
    },
  ];

  const getAdvisorType = async () => {
    const res = await advisorTypeApi.getAllAdvisorType();

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
  }, []);

  const handleDownloadFileAdvisorRequest = async (id: number, type: string) => {
    dispatch(setLoading());
    let query: any = {
      page: 1,
      limit: 1000000,
      sortBy: sortBy,
      sortType: sortType,
      sdate: startDate,
      edate: endDate,
      status: inputValueSearch.status,
      export_type: type ?? "pdf",
    };

    if (search) query = { ...query, search: search };

    await advisorApi
      .getDownloadAdvisorRequestById(id, query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          const title = "รายการคำขอให้เป็นที่ปรึกษา";
          const dateString = new Date().getTime();

          const fileName = `${title}-${dateString}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const handleDownloadFileAdvisorStudentRequest = async (
    id: number,
    type: string
  ) => {
    dispatch(setLoading());
    let query: any = {
      page: 1,
      limit: 1000000,
      sortBy: sortBy,
      sortType: sortType,
      sdate: startDate,
      edate: endDate,
      status: inputValueSearch.status,
      export_type: type ?? "pdf",
    };

    if (search) query = { ...query, search: search };

    await advisorApi
      .getDownloadAdvisorStudentRequestById(id, query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          const title = "รายการขอคำปรึกษา";
          const dateString = new Date().getTime();

          const fileName = `${title}-${dateString}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const handleDeleteAdvisor = async (id: number) => {
    if (id) {
      dispatch(setLoading());
      await advisorApi
        .deleteAdvisor(+id)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(
              "ยุติการเป็นอาจารย์ที่ปรึกษา เรียบร้อย",
              undefined,
              undefined,
              () => {
                navigate(routeName.cms.manageAdvisors);
              }
            );
          }
        })
        .catch(() => {
          alertError("ยุติการเป็นอาจารย์ที่ปรึกษา ไม่สำเร็จ");
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
    return;
  };

  const handleHoldAdvisorRequest = async (idAdvisor: number) => {
    if (idAdvisor) {
      let query: any = {
        page: 1,
        limit: 100000,
        status: "ตอบรับเป็นที่ปรึกษา",
      };

      if (search) query = { ...query, search: search };

      const resCancel = await advisorApi.getAdvisorRequestById(
        idAdvisor,
        query
      );
      const dataCancel = resCancel.data;

      const advisorRequests = dataCancel?.data?.advisor_request?.items || [];

      alertActive(
        "ยุติการเป็นอาจารย์ที่ปรึกษา",
        "ยุติการเป็นอาจารย์ที่ปรึกษา ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          if (resCancel.status < 300 && advisorRequests.length > 0) {
            dispatch(setLoading());
            try {
              await Promise.all(
                advisorRequests.map(async (request: any) => {
                  if (request.status !== "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา") {
                    await advisorRequestApi.updateStatusAdvisorRequest(
                      request.id_advisor_request,
                      "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา"
                    );
                  }
                })
              );

              handleDeleteAdvisor(idAdvisor);
            } catch (error) {
              alertError("สิ้นสุดการเป็นอาจารย์ที่ปรึกษา ไม่สำเร็จ");
            } finally {
              dispatch(unsetLoading());
            }
            // if (dataCancel.status < 300) {
            //   dispatch(setLoading());
            //   dataCancel?.data?.advisor_request?.items &&
            //   dataCancel?.data?.advisor_request?.items.map()
            // await advisorRequestApi
            //   .updateStatusAdvisorRequest(+idAdvisor, "สิ้นสุดการปรึกษา")
            //   .then((res) => {
            //     if (res.status < 300) {
            //       alertSuccess(
            //         "ยุติการเป็นอาจารย์ที่ปรึกษา",
            //         "ยุติการเป็นอาจารย์ที่ปรึกษา เรียบร้อยแล้ว",
            //         undefined,
            //         () => {
            //           getAdvisorRequestById(+idAdvisor);
            //         }
            //       );
            //     }
            //   })
            //   .catch(() => {
            //     alertError("สิ้นสุดการเป็นอาจารย์ที่ปรึกษา ไม่สำเร็จ");
            //   })
            //   .finally(() => {
            //     dispatch(unsetLoading());
            //   });
          } else {
            handleDeleteAdvisor(idAdvisor);
          }
        }
      );
    }
    return;
  };

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: "จัดการอาจารย์ที่ปรึกษาวิทยานิพนธ์",
            key: "1",
            pathName: routeName.cms.manageAdvisors,
          },
          {
            name: `ข้อมูลอาจารย์ที่ปรึกษา ${inputValue.adv_fullname ?? ""}`,
            key: "2",
            pathName: routeName.cms.manageAdvisors + `/${id}/detail`,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          ข้อมูลอาจารย์ที่ปรึกษา {inputValue.adv_fullname ?? ""}
        </Typography>
      </section>

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <StepperCustom
          step={tabStep}
          setStep={setTebStep}
          stepLabel={allStep}
          view={true}
        />
      </section>

      {tabStep === 0 ? (
        <>
          <section
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            {arrayCardInfo.map((item, index) => {
              return (
                <CardInfoComponent
                  key={index + 1}
                  color={item.color}
                  title={item.title}
                  amount={item.amount}
                  bgColor={item.bgColor}
                />
              );
            })}
          </section>
          <section className="w-full mt-4">
            <Typography variant="h6">รายการคำขอให้เป็นที่ปรึกษา</Typography>
          </section>

          <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
            <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
              <InputTextField
                startAdornment={<SearchOutlined />}
                placeholder="ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่"
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  debouncedApiCall({
                    searchItem: e.target.value,
                    setItem: setSearch,
                  })
                }
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <InputNewRangePicker
                value={selectedDateRange}
                onchange={handleRangeDate}
                onClear={handleClearRangeDate}
                allowClear
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <FilterSelect
                value={inputValueSearch.status ?? ""}
                labelId="status-id"
                selectId="status-select-id"
                options={[
                  {
                    id_status: "",
                    status_name: "ทุกสถานะ",
                  },
                  ...allStatusAdvisorRequestUtil.map((item) => ({
                    id_status: item,
                    status_name: item,
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.id_status} key={index + 1}>
                    {list.status_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValueSearch("status", e.target.value)
                }
              />
            </article>

            <article
              className="w-full col-span-12 lg:col-span-3 md:col-span-4 sm:col-span-12"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div>
                <DropdownButton
                  buttonName={"ดาวน์โหลดไฟล์"}
                  menuItems={[
                    {
                      id: 1,
                      name: "pdf",
                      onClick: () => {
                        if (id) {
                          handleDownloadFileAdvisorRequest(+id, "pdf");
                        }
                      },
                    },
                    {
                      id: 2,
                      name: "excel",
                      onClick: () => {
                        if (id) {
                          handleDownloadFileAdvisorRequest(+id, "exlse");
                        }
                      },
                    },
                  ]}
                  fullWidth={true}
                />
              </div>
            </article>
          </div>

          <section className="w-full mt-4">
            <ListAdvisoryRequest
              data={dataAdvisorRequest}
              page={page}
              setPage={setPage}
              totalItems={totalItems}
              sortBy={sortBy}
              sortType={sortType}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </section>
        </>
      ) : tabStep === 1 ? (
        <>
          <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
            <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
              <InputTextField
                startAdornment={<SearchOutlined />}
                placeholder="ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่"
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  debouncedApiCall({
                    searchItem: e.target.value,
                    setItem: setSearch,
                  })
                }
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <InputNewRangePicker
                value={selectedDateRange}
                onchange={handleRangeDate}
                onClear={handleClearRangeDate}
                allowClear
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
              <FilterSelect
                value={inputValueSearch.consultation_type ?? ""}
                labelId="consultation_type-id"
                selectId="consultation_type-select-id"
                placeholder="เลือกเรื่องที่ขอคำปรึกษา"
                options={[
                  {
                    id_type: "",
                    type_name: "ทุกเรื่องที่ขอคำปรึกษา",
                  },
                  ...dataAdvisorType.map((list) => ({
                    id_type: list.id_advisor_type,
                    type_name: list.advisor_type_name,
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.type_name} key={index + 1}>
                    {list.type_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValueSearch("consultation_type", e.target.value)
                }
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
              <FilterSelect
                value={inputValueSearch.status ?? ""}
                labelId="status-id"
                selectId="status-select-id"
                options={[
                  {
                    id_status: "",
                    status_name: "ทุกสถานะ",
                  },
                  ...allStatusConsultRequestUtil.map((item) => ({
                    id_status: item,
                    status_name: handleColorStatusConsultRequestUtil(
                      item,
                      profile && profile.user_type
                    ),
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.id_status} key={index + 1}>
                    {list.status_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValueSearch("status", e.target.value)
                }
              />
            </article>

            <article
              className="w-full col-span-12 lg:col-span-2 md:col-span-4 sm:col-span-12"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div>
                <DropdownButton
                  buttonName={"ดาวน์โหลดไฟล์"}
                  menuItems={[
                    {
                      id: 1,
                      name: "pdf",
                      onClick: () => {
                        if (id) {
                          handleDownloadFileAdvisorStudentRequest(+id, "pdf");
                        }
                      },
                    },
                    {
                      id: 2,
                      name: "excel",
                      onClick: () => {
                        if (id) {
                          handleDownloadFileAdvisorStudentRequest(+id, "exlse");
                        }
                      },
                    },
                  ]}
                  fullWidth={true}
                />
              </div>
            </article>
          </div>

          <section className="w-full mt-4">
            <ListConsultationRequest
              data={dataAdvisorRequestConsultaion}
              page={page}
              setPage={setPage}
              totalItems={totalItems}
              sortBy={sortBy}
              sortType={sortType}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              advisorId={id ? +id : 0}
            />
          </section>
        </>
      ) : null}

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.manageAdvisors);
          }}
          mode="del"
          buttonName="ยกเลิก"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            if (id) {
              handleHoldAdvisorRequest(+id);
            }
          }}
          mode={"cancel"}
          buttonName={"ยุติการเป็นอาจารย์ที่ปรึกษา"}
          btnProps={{
            width: "250px",
            margin: "12px",
          }}
        />
      </section>
    </div>
  );
};

export default ManageAdvisorDetail;
